
/**
 * Generate token based on success test
 */
export default async function generateToken(type : string): Promise<string> {
    const prefix = "STINGRAY";
    let token = `${prefix}-${type}`
    return token;
}